import { render, staticRenderFns } from "./SetPin.vue?vue&type=template&id=2dc1ec43&"
import script from "./SetPin.vue?vue&type=script&lang=js&"
export * from "./SetPin.vue?vue&type=script&lang=js&"
import style0 from "./SetPin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports